import * as React from 'react';

function SvgCheckCircle2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={28} height={28} fill="none" viewBox="0 0 28 28" {...props}>
      <path
        fill="#04006C"
        d="M14 .667C6.64.667.667 6.64.667 14S6.64 27.333 14 27.333 27.333 21.36 27.333 14 21.36.667 14 .667zm0 24C8.12 24.667 3.333 19.88 3.333 14S8.12 3.333 14 3.333 24.667 8.12 24.667 14 19.88 24.667 14 24.667zm5.173-15.614l-7.84 7.84-2.506-2.506c-.52-.52-1.36-.52-1.88 0-.52.52-.52 1.36 0 1.88L10.4 19.72c.52.52 1.36.52 1.88 0l8.787-8.787c.52-.52.52-1.36 0-1.88a1.344 1.344 0 00-1.894 0z"
      />
    </svg>
  );
}

export default SvgCheckCircle2;
